module.exports = __webpack_public_path__ + "img/card_menu_icon.81500a49.svg";